import React from "react";
import "./ExperienceHighlightBlock.css";

function ExperienceHighlightBlock({ backgroundImage, title, mainValue, mainDescription, features }) {
  return (
    <section
      className="block12"
      style={{ backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none' }}
    >
      <div className="block12-overlay">

        <h2 className="block12-title">{title || ''}</h2>

        <div className="block12-main">
          <h1>{mainValue || ''}</h1>
          <p>{mainDescription || ''}</p>
        </div>

        <div className="block12-features">
          {(features || []).map((feature, index) => (
            <div key={index} className="feature-box">
              <h3>{feature.title || ''}</h3>
              <p>{feature.description || ''}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default ExperienceHighlightBlock;
